/**
 * @file m站更换同城门店页面
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {SearchBar, Modal, Button, WhiteSpace, WingBlank,NavBar,Toast,Icon} from 'antd-mobile';
import * as shopChange from '../../redux/actions/shopChangeAction'
import {ShopList,CarComponents, NoData} from '../../component/shopChange/index';
import NavBarComponent from '../../component/common/NavBarComponent';
import {throttle, parseSearchToState, parseStateToSearch} from '../../util/util';
import moment from 'moment';
import {Http,urls} from '../../api/index'
import './shopChange.css';

const alert = Modal.alert;

class ShopChange extends Component {
    constructor(props) {
        super(props);

        props.cacheLifecycles.didCache(this.componentDidCache);
        props.cacheLifecycles.didRecover(this.componentDidRecover);
        
        this.state = {
            orderNo: '',
            text: '',
            isShowNodata:false,
            process: {},
            licenseVerify: true,
            verifyResult: {},
            unpayedContinueBill: {},
            customerServicePhone: '',
            car: {},
            order: {},
            months: [],
            weeks: [],
            hours: [],
            modalOpened21: false,
            backCityId:'',
            backCityName:'',
            backStoreId:'',
            backStoreName:'',
            backStorePoint:'',
            bookingBackcarTime:'',
            bookingGaincarTime:'',
            dateDiffNum:'',
            gaiCityId:'',
            gaiCityName:'',
            gaiStoreId:'',
            gaiStoreName:'',
            gaiStorePoint:'',
            bookingCarmodelId:'',
            bookingCarGradeId:'',
            pictureUrl:'',
            modelName:'',
            gearboxType:'',
            outputVolume:'',
            passengerCount:'',
            vehicleLicense:'',
            storeList:[],
            lsStoreName:'',
            lsStoreId:'',
            lsStorePoint:''
        };
    };
           
    componentDidCache = () => {}

    componentDidRecover = () => {
        this.getSameCityReplaceByStorePoint();
    }

    componentDidMount() {
        // 上个页面传过来的数据
        setTimeout(() => {}, 3000);
        const {location} = this.props;
        const search = location.search;
        let params = parseSearchToState(search);
        this.props.dispatch(shopChange.shopChangePass(params)).then(res => {
            Toast.loading('Loading...');
            this.getSameCityReplaceByStorePoint();
        })
    };

    // 门店更换列表
    getSameCityReplaceByStorePoint(){
        let url = urls.getSameCityReplaceByStorePoint;
        const {gaiStorePoint,gaiCityId,bookingCarGradeId,bookingCarmodelId,bookingBackcarTime,bookingGaincarTime} = this.props.shopChangeReducer.param;
        let data = {
            storePoint: gaiStorePoint,
            cityId: gaiCityId,
            bookingCarGradeId: bookingCarGradeId,
            bookingCarmodelId: bookingCarmodelId,
            bookingBackcarTime: bookingBackcarTime,
            bookingGaincarTime: bookingGaincarTime,
            orderProdType: 'D'
        };
        Http.post({ url, "data":data }).then(res => {
            Toast.hide();
            if(res.code == 0){
                this.setState({
                    storeList:res.data ? res.data : [],
                    isShowNodata:res.data ? false : true
                })
            }
        });
    };
    openModal21 = (storeInfo)=>{
        const {bookingCarmodelId,backStoreId,bookingBackcarTime,bookingGaincarTime} = this.props.shopChangeReducer.param;
        this.setState({
            lsStoreName:storeInfo.storeName,
            lsStoreId:storeInfo.storeId,
            lsStorePoint:`${storeInfo.longitude},${storeInfo.latitude}`
        },() => {
            Toast.loading('Loading...');
        });
        let where = {
            bookingCarmodelId: bookingCarmodelId,//传
            bookingGaincarStoreId:storeInfo.storeId,//点击的门店id
            bookingBackcarStoreId: backStoreId,//传
            bookingBackcarTimeStr: moment(bookingBackcarTime).format('YYYYMMDDHHmm').padEnd(14, '0'),
            bookingGaincarTimeStr: moment(bookingGaincarTime).format('YYYYMMDDHHmm').padEnd(14, '0'),
            orderProdType:'D'
        };
        let url = urls.makeShortOrderCheck;
        Http.post({url,data:where}).then(res => {
            Toast.hide();
            if(res.code == 0){
                this.setState({
                    modalOpened21: true,
                });
            }else{
                Toast.fail({
                    content: res.msg,
                    duration: 2000
                });
            }
        });
    };
    // 关闭modal
    onClose = key => () => {
        this.setState({
            [key]: false,
        });
    };
    // 检查门店
    checkStore = (IndexNa)=>{
        this.setState({modalOpened21:false},() => {
            Toast.loading('Loading...');
        });
        const { history,shopChangeReducer } = this.props;
        const { 
                backStoreId,
                backStoreName,
                backStorePoint,
                bookingBackcarTime,
                bookingGaincarTime,
                bookingCarmodelId,
            } = shopChangeReducer.param;
        let paramObj = JSON.parse(JSON.stringify(shopChangeReducer.param));
        let where = {
            bookingCarmodelId: bookingCarmodelId,
            bookingGaincarStoreId:this.state.lsStoreId,
            bookingBackcarStoreId:IndexNa == 'YES' ? this.state.lsStoreId : backStoreId,
            bookingBackcarTimeStr: moment(bookingBackcarTime).format('YYYYMMDDHHmm').padEnd(14, '0'),
            bookingGaincarTimeStr: moment(bookingGaincarTime).format('YYYYMMDDHHmm').padEnd(14, '0'),
            orderProdType:'D'
        };
        let url = urls.makeShortOrderCheck;
        Http.post({url,data:where}).then(res => {
            Toast.hide();
            if(res.code == 0){
                paramObj.backStoreId = IndexNa == 'YES' ? this.state.lsStoreId : backStoreId;
                paramObj.backStoreName = IndexNa == 'YES' ? this.state.lsStoreName : backStoreName;
                paramObj.backStorePoint = IndexNa == 'YES' ? this.state.lsStorePoint : backStorePoint;
                paramObj.gaiStoreId = this.state.lsStoreId;
                paramObj.gaiStoreName = this.state.lsStoreName;
                paramObj.gaiStorePoint = this.state.lsStorePoint;
                history.push({
                    pathname: '/order',
                    search: parseStateToSearch({...paramObj})
                });
            }else{
                Toast.fail({
                    content: res.msg,
                    duration: 2000
                });
            }
        });    
    };
    // 进入门店详情
    storeDetail = (storeId) =>{
        const { history } = this.props;
        history.push({
            pathname: '/storeDetail',
            search: parseStateToSearch({storeId})
        });
    };
    render() {
        const { param }  = this.props.shopChangeReducer;
        const { isShowNodata,storeList } = this.state;
        return (
            <div className="page shopChange" >
                <div className="shopChange-top">
                    <NavBarComponent>
                        <NavBar
                            mode="light"
                            icon={ <Icon type="left" color='#333' /> }
                            leftContent=""
                            onLeftClick={ () => this.props.history.goBack() }
                            >
                                更换同城门店
                        </NavBar>
                    </NavBarComponent>
                </div>
                <CarComponents data={param}/>
                <ShopList storeList={storeList} openModal21={this.openModal21} storeDetail={this.storeDetail} />
                <NoData isShowNodata={isShowNodata} />
                <Modal
                    visible={this.state.modalOpened21}
                    transparent
                    maskClosable={false}
                    closable={true}
                    animationType='fade'
                    onClose={this.onClose('modalOpened21')}
                    title="提示"
                    footer={[{ text: '否', onPress: () => { this.checkStore("NO") }},
                    { text: '是', onPress: () => { this.checkStore("YES")}}]}
                    wrapProps={{ onTouchStart: this.onWrapTouchStart }}
                    afterClose={() => {}}
                    >
                    <div>
                        更换门店之后，取车门店将与所选还车门店不一致，产生异店还车手续费，是否将还车门店也改为“{this.state.lsStoreName}门店”？
                    </div>
                </Modal>
           </div>
        );
    }
}

const mapState =  connect(state => {
    const { homeReducer,shopChangeReducer } = state
    return { homeReducer,shopChangeReducer }
});
export default mapState(ShopChange);